import firebase from "firebase";
import { config } from "@/firebaseConfig";
import Vue from "vue";
import { firestorePlugin } from "vuefire";

firebase.initializeApp(config);
Vue.use(firestorePlugin);
